import * as React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Tabs, Tab } from "@mui/material";

import { useTranslation } from "react-i18next";
import GeneratorEdit from "./components/GeneratorEdit";
import CogenConfig from "./components/CogenConfig";
import CogenPlanView from "./components/CoGenPlanView";
import SolarTable from "./components/SolarTable";
import Calendar from "../../components/DemandCalendar";

export default function CogenPage(props) {
	const { facility } = props;

	const { t } = useTranslation();

	const tab = sessionStorage.getItem("currentTab")
		? sessionStorage.getItem("currentTab")
		: "plan";

	const [activeTab, setActiveTab] = React.useState(tab);

	return (
		<>
			<Stack>
				<Box sx={{ borderBottom: 1, marginBottom: 0, borderColor: "divider" }}>
					<Tabs
						value={activeTab}
						onChange={(event, value) => setActiveTab(value)}
					>
						<Tab
							label={t("Daily plan")}
							value="plan"
							onClick={() => sessionStorage.setItem("currentTab", "plan")}
						/>
						<Tab
							label={t("Configuration")}
							value="config"
							onClick={() => sessionStorage.setItem("currentTab", "config")}
						/>
						<Tab
							label={t("Generators")}
							value="generators"
							onClick={() => sessionStorage.setItem("currentTab", "generators")}
						/>
						<Tab
							label={t("Solar Generation")}
							value="solar"
							onClick={() => sessionStorage.setItem("currentTab", "solar")}
						/>
						<Tab
							label={t("Demand Calendar")}
							value="calendar"
							onClick={() => sessionStorage.setItem("currentTab", "calendar")}
						/>
					</Tabs>
				</Box>
				{activeTab === "generators" && (
					<Box
						sx={{
							height: "calc(100vh - 120px)",
							width: "100%",
							p: 3,
						}}
					>
						<GeneratorEdit
							facility={facility}
						/>
					</Box>
				)}
				{activeTab === "config" && (
					<Box
						sx={{
							height: "calc(100vh - 120px)",
							width: "100%",
							p: 3,
						}}
					>
						<CogenConfig
							facility={facility}
						/>
					</Box>
				)}
				{activeTab === "plan" ? (
					<CogenPlanView
						facility={facility}
						clientInfo={props.clientInfo}
					/>
				) : null}

				{activeTab === "calendar" && (
					<Box
						height="calc(100vh - 300px)"
						maxHeight={1000}
						minWidth={700}
					>
						<Calendar
							t={t}
							facility={facility}
						/>
					</Box>
				)}

				{activeTab === "solar" && (
					<Box
						sx={{
							height: "calc(100vh - 120px)",
							width: "100%",
							p: 3,
						}}
					>
						<SolarTable
							facility={facility}
							clientInfo={props.clientInfo}
						/>
					</Box>
				)}
			</Stack>
		</>
	);
}
